module.exports = __webpack_public_path__ + "img/icon_m_lang.34640eb.svg";